import React, { FC } from 'react';
import { ChevronLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Typography from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/typography';
import HeaderLogo from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/header-logo';
import { ImageApi, LogoScale } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/types';
import { useFormat } from '@loomstateorg/shared-frontend/hooks/useFormat';
import { Category } from 'types/category';
import { Reference } from 'types/reference';
import { NextFrontasticImage } from 'frontastic/lib/image';
import Button from 'components/commercetools-ui/Button';

export interface Props {
  logo: NextFrontasticImage;
  logoLink: Reference;
  categories: Category[];
  onArrowClick: () => void;
  hideHeaderMenu: () => void;
  src: string;
  logoScale?: LogoScale;
  imageApi?: ImageApi;
}

const MobileMenuHeader: FC<Props> = ({
  onArrowClick,
  logo,
  logoLink,
  hideHeaderMenu,
  categories,
  src,
  logoScale = '1x',
  imageApi,
}) => {
  const { formatMessage } = useFormat({ name: 'common' });

  return (
    <div
      className="flex w-full items-center justify-between border-b border-neutral-400 px-20 py-10 align-middle"
      data-testid="mobile-menu-header"
    >
      {categories.length > 0 && (
        <div className="flex h-full items-center justify-start">
          <Button
            variant="ghost"
            size="fit"
            onClick={onArrowClick}
            className="px-0"
            aria-label={formatMessage({ id: 'back', defaultMessage: 'Back' })}
            data-testid="back"
          >
            <ChevronLeftIcon className="w-20" />
          </Button>
        </div>
      )}
      {categories.length <= 0 ? (
        <HeaderLogo
          src={src}
          logo={logo}
          logoLink={logoLink}
          logoScale={logoScale}
          imageApi={imageApi}
          onClick={hideHeaderMenu}
          imageClassName="flex justify-center text-center text-16 font-bold md:text-28"
        />
      ) : (
        <div className="flex w-full items-center justify-center whitespace-nowrap">
          <Typography align="center" medium fontSize={16} data-testid="mobile-menu-title">
            {categories[categories.length - 1].name}
          </Typography>
        </div>
      )}
      <div className="flex h-full items-center justify-end">
        <Button
          variant="ghost"
          size="xs"
          onClick={hideHeaderMenu}
          title={formatMessage({ id: 'close', defaultMessage: 'Close' })}
          aria-label={formatMessage({ id: 'close', defaultMessage: 'Close' })}
          className="px-0"
          data-testid="close"
        >
          <XMarkIcon className="w-24" />
        </Button>
      </div>
    </div>
  );
};

export default MobileMenuHeader;
